// Libraries

// MD2 PRO
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Card from '@mui/material/Card';

// @mui
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

// Components
import Area1 from './sections/Area1';
import Area2 from './sections/Area2';
import Area3 from './sections/Area3';
import Area4 from './sections/Area4';

function MainPage({ production, relatedID, aaroQueries, setValue }) {
    // Check if production data is available
    if (!production) {
        return (
            <MDBox mt={4} display="flex" justifyContent="center" alignItems="center" height="60vh">
                <Card>
                    <MDBox p={4} textAlign="center">
                        <CircularProgress color="info" />
                        <MDTypography variant="h6" mt={2}>
                            Üretim bilgileri yükleniyor...
                        </MDTypography>
                    </MDBox>
                </Card>
            </MDBox>
        );
    }

    return (
        <MDBox mt={4}>
            <Grid container spacing={3}>
                {/* Middle Content Area */}
                <Grid
                    size={{
                        xs: 12,
                        lg: 3,
                    }}
                >
                    <Area1 production={production} relatedID={relatedID} aaroQueries={aaroQueries} />
                </Grid>
                {/* Left Sidebar */}

                {/* Right Sidebar */}
                <Grid
                    size={{
                        xs: 12,
                        lg: 3,
                    }}
                >
                    <Area2 production={production} relatedID={relatedID} aaroQueries={aaroQueries} />
                </Grid>

                {/* Right Sidebar */}
                <Grid
                    size={{
                        xs: 12,
                        lg: 3,
                    }}
                >
                    <Area3 production={production} relatedID={relatedID} aaroQueries={aaroQueries} />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        lg: 3,
                    }}
                >
                    <Area4
                        production={production}
                        relatedID={relatedID}
                        aaroQueries={aaroQueries}
                        setValue={setValue}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default MainPage;
